/** La cible de toucher du livre : 44 px. */
export const TOUCH_TARGET = 44

/** Ce qu'il faut ajouter de chaque côté d'un élément de `size` px pour que sa zone atteigne la cible. */
export const slopTo = (size: number): number => Math.max(0, Math.ceil((TOUCH_TARGET - size) / 2))
